module.exports = __webpack_public_path__ + "ef43027667a1b00877cf0b3c0d932a12.MP3";